import { Chip, ChipProps } from "@mui/material";
import { WasteInvoiceImportStatus } from "generated-graphql/graphql";

const IMPORT_LABELS: Record<WasteInvoiceImportStatus, string> = {
  [WasteInvoiceImportStatus.Queued]: "Queued",
  [WasteInvoiceImportStatus.Running]: "Importing",
  [WasteInvoiceImportStatus.Succeeded]: "Imported",
  [WasteInvoiceImportStatus.Failed]: "Import failed",
  [WasteInvoiceImportStatus.Cancelled]: "Cancelled",
};

const IMPORT_COLORS: Record<WasteInvoiceImportStatus, ChipProps["color"]> = {
  [WasteInvoiceImportStatus.Queued]: "default",
  [WasteInvoiceImportStatus.Running]: "info",
  [WasteInvoiceImportStatus.Succeeded]: "success",
  [WasteInvoiceImportStatus.Failed]: "error",
  [WasteInvoiceImportStatus.Cancelled]: "warning",
};

export function InvoiceImportStatusChip({ status }: { status: WasteInvoiceImportStatus }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      color={IMPORT_COLORS[status]}
      label={IMPORT_LABELS[status]}
    />
  );
}
